module.exports = __webpack_public_path__ + "3b93f241746be1b7bc28874c9abcf74d.MP3";